import { AxisBottom } from '../../../primitives/axis/axis/AxisBottom';
import { AxisLeft } from '../../../primitives/axis/axis/AxisLeft';
import { useLineData } from '../providers/data';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function LineAxes() {
  const {
    xScale,
    yScale,
    height,
    width
  } = useLineData();
  // We should make this check better. Move out the string constructor.s
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AxisLeft, {
      scale: yScale
    }), /*#__PURE__*/_jsx(AxisBottom, {
      scale: xScale,
      top: height,
      left: width
    })]
  });
}